import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-slate-950 text-slate-500 py-8" data-id="element-8">
        <div className="max-w-4xl mx-auto px-5 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-9">
          <p data-id="element-10">
            © 2025 The Clean &amp; Close AI Kit · Todos los derechos reservados
          </p>
          <div className="flex items-center gap-6" data-id="element-11">
            <button onClick={() => setOpenModal('privacy')} className="text-slate-400 hover:text-teal-400 transition-colors duration-200 underline underline-offset-2" data-id="element-12">
              Política de Privacidad
            </button>
            <button onClick={() => setOpenModal('terms')} className="text-slate-400 hover:text-teal-400 transition-colors duration-200 underline underline-offset-2" data-id="element-13">
              Términos de Uso
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-14">
        <p className="text-slate-500 text-xs" data-id="element-15">Última actualización: 2025</p>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-16">
          1. Información que recopilamos
        </h3>
        <p data-id="element-17">
          Al realizar una compra en nuestro sitio, recopilamos información
          básica necesaria para procesar tu pedido, incluyendo tu nombre y
          dirección de correo electrónico. No almacenamos información de
          tarjetas de crédito — los pagos son procesados de forma segura por
          plataformas de pago de terceros.
        </p>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-18">
          2. Uso de la información
        </h3>
        <p data-id="element-19">Utilizamos tu información únicamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-20">
          <li data-id="element-21">Entregar el producto digital que compraste.</li>
          <li data-id="element-22">Enviarte comunicaciones relacionadas con tu compra.</li>
          <li data-id="element-23">Mejorar nuestros productos y servicios.</li>
        </ul>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-24">
          3. Cookies
        </h3>
        <p data-id="element-25">
          Este sitio puede utilizar cookies básicas para mejorar tu experiencia
          de navegación. No utilizamos cookies para rastrear tu actividad fuera
          de este sitio.
        </p>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-26">
          4. Compartir información con terceros
        </h3>
        <p data-id="element-27">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago o cumplir
          con obligaciones legales.
        </p>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-28">
          5. Seguridad
        </h3>
        <p data-id="element-29">
          Tomamos medidas razonables para proteger tu información personal. Sin
          embargo, ningún método de transmisión por Internet es 100% seguro.
        </p>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-30">
          6. Cambios a esta política
        </h3>
        <p data-id="element-31">
          Podemos actualizar esta política en cualquier momento. Los cambios
          serán publicados en esta página con la fecha de actualización.
        </p>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos de Uso" data-id="element-32">
        <p className="text-slate-500 text-xs" data-id="element-33">Última actualización: 2025</p>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-34">
          1. Aceptación de los términos
        </h3>
        <p data-id="element-35">
          Al comprar o utilizar The Clean &amp; Close AI Kit, aceptas estos
          Términos de Uso en su totalidad. Si no estás de acuerdo con alguno de
          estos términos, no debes utilizar este producto.
        </p>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-36">
          2. Descripción del producto
        </h3>
        <p data-id="element-37">
          The Clean &amp; Close AI Kit es un producto digital educativo diseñado
          para dueñas de negocios de limpieza en USA. Incluye guiones de ventas,
          prompts de IA, y materiales de capacitación en formato digital.
        </p>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-38">
          3. Licencia de uso
        </h3>
        <p data-id="element-39">
          Al comprar este kit, obtienes una licencia personal, no transferible,
          para usar el contenido en tu propio negocio. No está permitido:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-40">
          <li data-id="element-41">Revender, redistribuir o compartir el contenido con terceros.</li>
          <li data-id="element-42">
            Reproducir el material para uso comercial fuera de tu negocio
            personal.
          </li>
          <li data-id="element-43">Reclamar la autoría del contenido.</li>
        </ul>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-44">
          4. Política de reembolsos
        </h3>
        <p data-id="element-45">
          Debido a la naturaleza digital e inmediata del producto,{' '}
          <strong className="text-slate-800" data-id="element-46">no ofrecemos reembolsos</strong>{' '}
          una vez que el acceso ha sido entregado. Te recomendamos leer la
          descripción completa del producto antes de realizar tu compra.
        </p>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-47">
          5. Resultados y garantías
        </h3>
        <p data-id="element-48">
          Los resultados mencionados en esta página son ejemplos ilustrativos.
          No garantizamos resultados específicos, ya que estos dependen del
          esfuerzo, la aplicación y las circunstancias individuales de cada
          negocio.
        </p>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-49">
          6. Limitación de responsabilidad
        </h3>
        <p data-id="element-50">
          En ningún caso seremos responsables por daños indirectos, incidentales
          o consecuentes derivados del uso o la imposibilidad de uso de este
          producto.
        </p>

        <h3 className="font-heading font-bold text-slate-800 text-base mt-4" data-id="element-51">
          7. Modificaciones
        </h3>
        <p data-id="element-52">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. El uso continuado del producto implica la aceptación de los
          términos actualizados.
        </p>
      </LegalModal>
    </>;
}